import { Navigate, useParams } from "react-router";

import { caseActionPath, ROUTES } from "@/app/routes";
import { Skeleton } from "@/components/ui/skeleton";
import { useTaskForm } from "@/features/new-application/use-start-application";

/**
 * 旧・判定画面（`/approval-requests/:caseId/:taskGuid`）を案件詳細へ送り直す。
 *
 * 承認も提出と同じく案件詳細の操作パネルで行う（同じ操作の画面を 2 つ持たない）。
 * この URL は利用者のブックマーク・共有リンクに残るので消さない。
 *
 * 案件詳細はモデル id を要求するがこの URL には無いので、タスクから取る。
 * 取れないとき（処理済み・権限が無い）は承認リクエストの一覧へ逃がす。
 */
export function ApprovalReviewRedirect() {
  const params = useParams();
  const caseId = Number.parseInt(params.caseId ?? "", 10);
  const taskGuid = params.taskGuid ?? "";

  const isValid = Number.isFinite(caseId) && taskGuid !== "";
  const form = useTaskForm(isValid ? { caseId, taskGuid } : null);

  if (!isValid) return <Navigate to={ROUTES.approvalRequests} replace />;
  if (form.isPending) return <Skeleton className="h-24 w-full" />;

  const processModelId = form.data?.processModelId ?? null;
  if (processModelId === null) {
    return <Navigate to={ROUTES.approvalRequests} replace />;
  }

  return <Navigate to={caseActionPath(caseId, processModelId)} replace />;
}
